<script context="module">
    import { apiMethods } from "../../../Services/index.svelte";
    import { presetRuleType } from "../../../Utils/utilEnums.svelte";

    import { isObjectEmpty } from "../../../Utils/utilFunctions.svelte";

    export const getSubmitBtnDisable = (
        data,
        insuranceTypes = [],
        totalUnits = 0,
    ) => {
        let res = {
            disable: false,
            tooltip: "",
        };

        if (
            !data ||
            isObjectEmpty(data) ||
            !data.hasOwnProperty("name") ||
            data.name == ""
        ) {
            res.disable = true;
            res.tooltip = "Please enter a name for the preset";
            return res;
        }

        if (
            !insuranceTypes.length ||
            insuranceTypes.length != presetRuleType.length
        ) {
            res.disable = true;
            res.tooltip = "Inner error occurs - insurance types mis-match";
            return res;
        }

        const nibInsurance = insuranceTypes.find(
            (it) => it.presetRuleType == 2,
        );

        // asa items type hide NIB insurance
        // no provider selected for NIB insurance
        // if NIB insurance hide max gap checkbox means no restrictions of total item units
        if (
            nibInsurance.isHidden ||
            !nibInsurance.doctorProviderId ||
            !nibInsurance.showCapCheckbox
        ) {
            return res;
        }

        res.disable = totalUnits < 5;
        res.tooltip = res.disable
            ? "Please complete items to at least 5 units"
            : "";

        return res;
    };

    export const getOptionLabel = (option, type) => {
        const isMBSLabel = type == "mbs";

        return `${isMBSLabel ? option.itemNum : option.itemCode} ${
            isMBSLabel
                ? option.subItemNum
                    ? `(${option.subItemNum})`
                    : ""
                : option.subItemCode != "0"
                  ? `(${option.subItemCode})`
                  : ""
        } - ${
            option.infoShortTitle ? option.infoShortTitle : option.description
        }`;
    };

    export const getInsuranceTypes = (
        data,
        allInsuranceTypes,
        defaultBillingRule,
        showNonPreferredADF,
    ) => {
        const billingRules = data.billingRules ?? [];

        const { useAsaCodes, isFromEncounter } = data;

        let res = [];

        if (useAsaCodes == undefined) return res;

        if (useAsaCodes && !isFromEncounter) {
            const allowTypes = ["Overseas", "CosmeticAndThirdParty"];

            if (showNonPreferredADF) allowTypes.push("NonPreferedADF");

            res = presetRuleType.map((rule) => {
                rule.isHidden = !allowTypes.includes(rule.type);

                const targetBillingRule =
                    allInsuranceTypes.find(
                        (br) => br.presetRuleType == rule.id,
                    ) ??
                    billingRules.find((br) => br.presetRuleType == rule.id);

                if (targetBillingRule)
                    return {
                        ...targetBillingRule,
                        billingRuleId: targetBillingRule.billingRuleId
                            ? targetBillingRule.billingRuleId >= 0
                                ? targetBillingRule.billingRuleId
                                : String(targetBillingRule.billingRuleId)
                            : 0,
                        isHidden: rule.isHidden,
                        description: rule.description,
                        presetRuleType: rule.id,
                        info: rule.info,
                        presetGroup: rule.group
                    };
                else
                    return {
                        ...defaultBillingRule,
                        isHidden: rule.isHidden,
                        description: rule.description,
                        presetRuleType: rule.id,
                        info: rule.info,
                        presetGroup: rule.group
                    };
            });
        } else {
            const showCapCheckboxTypes = ["PrivateFundUnitValueOver35", "DoctorsHealthFundTopCover", "OverseasWithFund", "NIBGroupFunds"];

            res = presetRuleType.map((rule) => {
                if (rule.id == 6) rule.isHidden = !showNonPreferredADF;
                else rule.isHidden = false;

                rule.showCapCheckbox = showCapCheckboxTypes.includes(rule.type);

                const targetBillingRule =
                    allInsuranceTypes.find(
                        (br) => br.presetRuleType == rule.id,
                    ) ??
                    billingRules.find((br) => br.presetRuleType == rule.id);

                if (targetBillingRule)
                    return {
                        ...targetBillingRule,
                        billingRuleId: targetBillingRule.billingRuleId
                            ? targetBillingRule.billingRuleId >= 0
                                ? targetBillingRule.billingRuleId
                                : String(targetBillingRule.billingRuleId)
                            : 0,
                        isHidden: rule.isHidden,
                        showCapCheckbox: rule.showCapCheckbox,
                        description: rule.description,
                        presetRuleType: rule.id,
                        info: rule.info,
                        presetGroup: rule.group
                    };
                else
                    return {
                        ...defaultBillingRule,
                        isHidden: rule.isHidden,
                        showCapCheckbox: rule.showCapCheckbox,
                        description: rule.description,
                        presetRuleType: rule.id,
                        info: rule.info,
                        presetGroup: rule.group
                    };
            });
        }

        return res;
    };

    export const getDoctorInsuranceTypesForImport = (account, useAsaCodes = false) => {
        const showNonPreferredADF = account.providers?.some(
                ({ isPreferredDefence }) => !isPreferredDefence,
            );
        const defaultBillingRule = {
            accountId: account.id,
            billingRuleId: 0,
            doctorProviderId: 0,
        };

        let res = [];

        if (useAsaCodes) {
            const allowTypes = ["Overseas", "CosmeticAndThirdParty"];

            if (showNonPreferredADF) allowTypes.push("NonPreferedADF");

            res = presetRuleType.map((rule) => ({
                    ...defaultBillingRule,
                    isHidden: !allowTypes.includes(rule.type),
                    description: rule.description,
                    presetRuleType: rule.id,
                })
            );
        } else {
            const showCapCheckboxTypes = ["PrivateFundUnitValueOver35"];

            res = presetRuleType.map((rule) => {
                if (rule.id == 6) rule.isHidden = !showNonPreferredADF;
                else rule.isHidden = false;

                return {
                    ...defaultBillingRule,
                    isHidden: rule.isHidden,
                    showCapCheckbox: showCapCheckboxTypes.includes(rule.type),
                    description: rule.description,
                    presetRuleType: rule.id,
                };
            });
        }

        return res;
    }

    export const getTotalUnits = (useAsaCodes, asaItems, mbsItems, procedureLength) => {
        let count = 0;

        count = useAsaCodes
            ? asaItems.reduce((sum, { amaUnits }) => (sum += amaUnits), count)
            : mbsItems.reduce(
                  (sum, { basicUnits }) => (sum += basicUnits),
                  count,
              );
        
        if(useAsaCodes && procedureLength && procedureLength > 0) {
            count += _getAsaTimeItemUnits(procedureLength);
        }

        return count;
    };

    const _getAsaTimeItemUnits = (timeMinutes) => {
        if (timeMinutes <= 120) return Math.ceil(timeMinutes / 15);
        else if (timeMinutes <= 240)
            return 8 + Math.ceil((timeMinutes - 120) / 10);
        else return 20 + Math.ceil((timeMinutes - 240) / 5);
    };

    export const syncItemsByItemType = (
        presetData,
        mbsItems = [],
        asaItems = [],
    ) => {
        const { useAsaCodes, accountId } = presetData;

        presetData.mbsCodes = useAsaCodes
            ? []
            : mbsItems.map((item) => ({
                  accountId,
                  itemNum: item.itemNum,
                  subItemNum: item.subItemNum,
              }));
        presetData.asaCodes = useAsaCodes
            ? asaItems.map((item) => ({
                  accountId,
                  itemCode: item.itemCode,
                  subItemCode: item.subItemCode,
              }))
            : [];

        return presetData;
    };

    export const syncBillingRules = (presetData, insuranceTypes = []) => {
        presetData.billingRules = insuranceTypes.map((it) => {
            if (it.isHidden)
                return {
                    ...it,
                    billingRuleId: 0,
                    doctorProviderId: 0,
                    maxGapProtection: false,
                };

            return {
                ...it,
                doctorProviderId: it.doctorProviderId ?? 0,
                maxGapProtection: it.showCapCheckbox
                    ? (it.maxGapProtection ?? false)
                    : false,
            };
        });

        return presetData;
    };

    export const getSelectedItems = (selectedItems = [], newItem) => {
        const { infoType } = newItem;
        if (
            infoType == "Surgery" ||
            infoType == "Time" ||
            infoType == "Consults"
        )
            selectedItems = selectedItems.filter(
                (item) => item.infoType != infoType,
            );

        return [...selectedItems, newItem];
    };

    export const getSelectedPresetApplicableRuleForEncounter = async (selectedPreset, patientEncounter, objDetails) => {
        let insuranceType, insuranceId, scheduledDate, coverType;
        if(isObjectEmpty(objDetails)){
            //get insurance type from patient
            if(patientEncounter.patient){
                insuranceType = patientEncounter.patient.insuranceType;
                insuranceId = patientEncounter.patient.insuranceId;
                coverType = patientEncounter.patient.insurance; //for cover type
            }
        } else {
            //get insurance type from latestObjDetails
            insuranceType = objDetails.patientInsuranceType;
            insuranceId = objDetails.patientInsuranceId;
            coverType = objDetails.patientInsurance; //for cover type
        }

        scheduledDate = patientEncounter.scheduledDate;

        //determine which rule is applicable for this encounter

        if(insuranceType == 0 || insuranceType == 1 || insuranceType == 2) {
            //private or overseas with fund
            if(insuranceId > 0){
                const fund = await apiMethods.getMethod
                    .getInsuranceFundUnitValue(insuranceId)
                    .then((res) => res);

                let targetPresetInsuranceTypeIndex = 0;
                if (fund) {
                    const { insuranceCode } = fund;

                    targetPresetInsuranceTypeIndex =
                        insuranceCode == "NIB"
                            ? 2
                            : (insuranceCode == "AHSA" && coverType == "Top Cover" ? //doctors healthfund top cover
                                7 : ["CDH", "LHS", "AUH"].includes(
                                    insuranceCode.toUpperCase(),
                                )
                              ? 1
                              : 0);
                }

                return selectedPreset.billingRules.find((r) => r.presetRuleType == targetPresetInsuranceTypeIndex);
            }
        }

        switch(insuranceType){
            case 10:
                if(insuranceId > 0) {
                    return selectedPreset.billingRules.find((r) => r.presetRuleType == 8);
                }
                return selectedPreset.billingRules.find((r) => r.presetRuleType == 4);
            case 11:
                return selectedPreset.billingRules.find((r) => r.presetRuleType == 3);
            case 15:
            case 18:
                return selectedPreset.billingRules.find((r) => r.presetRuleType == 5);
            case 26:
                return selectedPreset.billingRules.find((r) => r.presetRuleType == 6);
        }

        return {}; //empty object
    }
</script>
